<h2>Verificar Cadastro</h2>

<div class="tds-row tds-u-mt3">
  <app-input
    label="Documento do motorista"
    [(ngModel)]="driverIdSearch"
    (keydown.enter)="search()"
    maxLength="14"
    cpfMask
  ></app-input>
  <app-button
    class="tds-u-ml1"
    text="Pesquisar"
    (clicked)="search()"
  ></app-button>
</div>

<app-table
  class="tds-u-mt2"
  [headers]="headers"
  [content]="driversList"
  [showFilter]="false"
  [hasEdit]="true"
  [hasDelete]="true"
  (editing)="edit($event)"
  (deleting)="confirmDelete($event)"
></app-table>
